import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { PiggyBank, ArrowRight } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1558591710-4b4a1ae0f04d?auto=format&fit=crop&w=1400&q=70";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Password minimal 6 karakter");
      return;
    }
    setBusy(true);
    try {
      await register(email.trim(), password, name.trim());
      toast.success("Akun berhasil dibuat!");
      nav("/");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 grid lg:grid-cols-2">
      <div className="hidden lg:block relative overflow-hidden">
        <img src={HERO_IMG} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tr from-emerald-950/60 via-blue-900/20 to-transparent" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/15 backdrop-blur px-3 py-1 text-xs uppercase tracking-[0.2em]">
            <PiggyBank className="w-3.5 h-3.5" /> Mulai Gratis
          </div>
          <h2 className="mt-6 text-4xl font-display font-semibold leading-tight tracking-tight">
            Rapikan aset. Kenali pertumbuhan.
          </h2>
          <p className="mt-3 text-white/80 max-w-md">
            Dari kas, kripto, emas, hingga properti — semua dalam satu jurnal bulanan yang enak dibaca.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-12">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="register-form">
          <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">
            Buat akun baru
          </h1>
          <p className="mt-2 text-slate-600">Gratis. Kategori default sudah disiapkan untuk Anda.</p>

          <div className="mt-8 space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="name" className="text-xs uppercase tracking-[0.1em] text-slate-500 font-semibold">Nama</Label>
              <Input id="name" required value={name} onChange={(e) => setName(e.target.value)}
                data-testid="register-name-input" placeholder="Nama lengkap" className="h-11" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="email" className="text-xs uppercase tracking-[0.1em] text-slate-500 font-semibold">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="register-email-input" placeholder="anda@email.com" className="h-11" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password" className="text-xs uppercase tracking-[0.1em] text-slate-500 font-semibold">Password</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="register-password-input" placeholder="Minimal 6 karakter" className="h-11" />
            </div>
          </div>

          <Button type="submit" disabled={busy} data-testid="register-submit-button"
            className="mt-6 w-full h-11 bg-blue-600 hover:bg-blue-700 rounded-md font-medium">
            {busy ? "Memproses…" : (<span className="inline-flex items-center gap-2">Daftar <ArrowRight className="w-4 h-4" /></span>)}
          </Button>

          <p className="mt-6 text-sm text-slate-600">
            Sudah punya akun?{" "}
            <Link to="/login" className="text-blue-600 hover:text-blue-700 font-medium" data-testid="goto-login-link">
              Masuk di sini
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
